export default __webpack_public_path__ + "static/media/digiimg4.21429c9e.jpg";